__turbopack_context__.v({
  "description": "TextField-module__RIK1-q__description",
  "error": "TextField-module__RIK1-q__error",
  "icon": "TextField-module__RIK1-q__icon",
  "input": "TextField-module__RIK1-q__input",
  "inputWrap": "TextField-module__RIK1-q__inputWrap",
  "label": "TextField-module__RIK1-q__label",
  "required": "TextField-module__RIK1-q__required",
  "root": "TextField-module__RIK1-q__root",
});
